<template>
  <div>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row border-bottom border-secondary mb-1">
      <div class="col-12">
        <b-form @submit.prevent="selectChange()">
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                  label="CPF/CNPJ">
                <the-mask class="form-control" v-model="filtro.pes_cpfcnpj"
                          :mask="['###.###.###-##', '##.###.###/####-##']"/>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                  label="Nome/Razão Social"
                  label-for="pes_nome">
                <input
                    id="pes_nome"
                    v-model="filtro.pes_nome"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                  label="Nome Fantasia"
                  label-for="eco_nome_fantasia">
                <input
                    id="eco_nome_fantasia"
                    v-model="filtro.eco_nome_fantasia"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Código"
                  label-for="eco_codigo">
                <input
                    id="eco_codigo"
                    v-model="filtro.eco_codigo"
                    type="text"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Classificação" label-for="tab_103classificacao">
                <select id="tab_103classificacao"
                        @change="selectChange()"
                        v-model="filtro.tab_103classificacao"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="921">Autônomos</option>
                  <option value="922">Avulsos</option>
                  <option value="923">Prestadores de Serviços</option>
                  <option value="924">Não prestadores ou Substitutos Trib</option>
                  <option value="925">Escritórios de Contabilidade</option>
                  <option value="926">Cartórios</option>
                  <option value="927">Sócios</option>
                  <option value="928">Tabelião</option>
                  <option value="929">Instituições Financeiras</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Tributação" label-for="eco_tributacao">
                <select id="eco_tributacao"
                        @change="selectChange()"
                        v-model="filtro.eco_tributacao"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="1">Microempreendedor Individual</option>
                  <option value="2">Simples Nacional</option>
                  <option value="3">Estimativo</option>
                  <option value="4">Sociedade de Profissionais</option>
                  <option value="5">Cooperativas</option>
                  <option value="6">Sem Tributação Especial</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Situação" label-for="tab_107situacao">
                <select id="tab_107situacao"
                        @change="selectChange()"
                        v-model="filtro.tab_107situacao"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="1002">Nula</option>
                  <option value="1003">Ativa</option>
                  <option value="1004">Suspensa</option>
                  <option value="1005">Inapta</option>
                  <option value="1006">Ativa Não Regular</option>
                  <option value="1007">Baixada</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Empresas por Página" label-for="nota_pagina">
                <select id="nota_pagina"
                        @change="selectChange()"
                        v-model="filtro.nota_pagina"
                        class="custom-select" type="text">
                  <option value="10">10/Pág.</option>
                  <option value="30">30/Pág.</option>
                  <option value="50">50/Pág.</option>
                  <option value="80">80/Pág.</option>
                  <option value="100">100/Pág.</option>
                  <option value="200">200/Pág.</option>
                  <option value="500">500/Pág.</option>
                  <option value="800">800/Pág.</option>
                  <option value="1000">1000/Pág.</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="'" class="text-white">
                <button type="submit"
                        class="btn btn-label btn-primary mr-3"><i
                    class="bx bx-search label-icon"></i>
                  Consultar
                </button>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <div v-show="!list_empresas.length || list_empresas.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem empresas liberadas
    </div>
    <div class="row border-bottom border-secondary mb-1">
      <p class="mb-1 font-weight-medium">Total de Empresas: {{ total_empresa }}</p>
    </div>
    <div v-for="s in list_empresas" :key="s.eco_codigo" class="row">
      <div class="col-md-12 mb-1 border-bottom border-secondary">

        <div class="row">
          <div class="col-md-3">
            <b-form-group class="my-1" label="Código">
              <h6 class="mb-0">
              <span class="text-body font-weight-bold">
                 <router-link tag="a"
                              :to="{name: 'admin-pessoas-autorizadas-detalhe', params: {eco_codigo: s.eco_codigo}}">
                    {{ s.eco_codigo }}
                  </router-link></span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="my-1" label="CPF/CNPJ">
              <h6 class="mb-0">
                <span v-if="s.pes_cpfcnpj.length < 12">{{ s.pes_cpfcnpj | VMask('###.###.###-##') }}</span>
                <span v-else>{{ s.pes_cpfcnpj| VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="my-1" label="Situação">
              <h6 class="mb-0">
                <span v-show="s.tab_107situacao==='1002'" class="badge badge-dark font-size-12">Nula</span>
                <span v-show="s.tab_107situacao==='1003'" class="badge badge-success font-size-12">Ativa</span>
                <span v-show="s.tab_107situacao==='1004'" class="badge badge-warning font-size-12">Suspensa</span>
                <span v-show="s.tab_107situacao==='1005'" class="badge badge-dark font-size-12">Inapta</span>
                <span v-show="s.tab_107situacao==='1006'" class="badge badge-warning font-size-12">Ativa Não Regular</span>
                <span v-show="s.tab_107situacao==='1007'" class="badge badge-danger font-size-12">Baixada</span>
                <span v-show="s.mun_codigo==='0'" class="badge badge-light ml-2 font-size-12">Sem endereço comercial</span>
              </h6>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-form-group class="my-1" label="Nome/Razão Social (Nome Fantasia)">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ s.pes_nome }}  ({{ s.eco_nome_fantasia }})</span>
              </h6>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <b-form-group class="my-1" label="Classificação">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ s.tab_103nome }}</span>
              </h6>
            </b-form-group>
          </div>

          <div class="col-md-4">
            <b-form-group class="my-1" label="Tributação">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ s.eco_tributacao | tributacaoPessoa }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4 mt-3">
            <button type="button" @click="setCurrentEmpresa(s)" class="btn btn-primary btn-sm mb-1 mr-3">
              <i class="mdi mdi-check"></i> Selecionar
            </button>
            <button type="button" @click="detalhe(s)" class="btn btn-outline-info btn-sm mb-1 mr-2">
              <i class="bx bxs-user-detail"></i> Detalhes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="list_empresas && list_empresas.length > 0" class="row">
      <div class="col-lg-12">
        <paginate
            v-model="filtro.pagina"
            :page-count="total_paginas"
            :page-range="3"
            :margin-pages="3"
            :click-handler="proximaPagina"
            :prev-text="'Página anterior'"
            :next-text="'Próxima página'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :page-link-class="'page-link'"
            :container-class="'pagination pagination-rounded justify-content-center mt-4'"
            :page-class="'page-item'">
        </paginate>
      </div>
    </div>
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate'
import {TheMask} from 'vue-the-mask'
import {listEmpresas} from "@/api/admin/pessoas/pessoas";
import Aguarde from "@/components/widgets/aguarde.vue";
import {authMethods} from "@/state/helpers";
import router from "@/router";

export default {
  components: {
    Aguarde,
    Paginate,
    TheMask
  },
  data() {
    return {
      httpSend: false,
      filtro: {
        nota_pagina: "10",
        pagina: 1,
        eco_codigo: "",
        pes_nome: "",
        eco_nome_fantasia: "",
        pes_cpfcnpj: "",
        tab_103classificacao: "",
        tab_107situacao: "",
        eco_tributacao: "",
      },
      total_empresa: 0,
      total_paginas: 0,
      list_empresas: []
    };
  },
  created() {
    if (this.$route.query.nota_pagina) {
      this.filtro = this.$route.query;
      this.filtro.pagina = parseInt(this.filtro.pagina)
      this.getEmpresas();
    } else {
      this.getEmpresas();
    }
  },
  methods: {
    ...authMethods,
    setCurrentEmpresa(empresa) {
      if (empresa) {
        empresa.redirectFrom = 'painel';
        this.empresaAtual(empresa).catch(() => {
        }).finally(() => {
        })
      }
    },
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = parseInt(pageNum);
      this.getEmpresas();
    },
    getEmpresas() {
      this.httpSend = true;
      listEmpresas(this.filtro).then(result => {
        this.total_empresa = result.dados.count;
        this.total_paginas = result.dados.paginas;
        this.list_empresas = result.dados.empresas
        router.replace({query: {...this.filtro, t: new Date().getTime().toString()}})
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    selectChange() {
      this.filtro.pagina = 1;
      this.getEmpresas();
    },
    detalhe(empresa) {
      this.$router.push({
        name: 'admin-pessoas-autorizadas-detalhe',
        params: {eco_codigo: empresa.eco_codigo}
      })
    },
  }
};
</script>

